<template>
  <BaseLink
    :to="url"
    class="ui-news-list-row-hina"
  >
    <div class="ui-news-list-row-hina-inner">
      <BaseIcon
        name="mdi/bullhorn"
        size="size-3"
        class="icon"
        alt=""
      />
      <div class="ui-news-list-row-hina-body">
        <span class="ui-news-list-row-hina-date">{{ date }}</span>
        <span class="ui-news-list-row-hina-heading">{{ title }}</span>
      </div>
    </div>
  </BaseLink>
</template>

<script setup lang="ts">

interface Props {
  url: string
  date: string
  title: string
}

withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.ui-news-list-row-hina {
  display: block;

  &:hover .ui-news-list-row-hina-heading {
    text-decoration: underline;
  }
}

.ui-news-list-row-hina-inner {
  display: flex;
  padding: 1rem;
  gap: 0.5rem;
  background-color: $white;
  border: 1px solid $hina-separator-dark;
  border-radius: 1rem;

  .icon {
    flex-shrink: 0;
    color: $hina-placeholder;
  }
}

.ui-news-list-row-hina-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.ui-news-list-row-hina-date {
  font-size: $size-7;
  color: $hina-text-sub;
}

.ui-news-list-row-hina-heading {
  font-size: 1rem;
  font-weight: 700;
}
</style>
